document.addEventListener('DOMContentLoaded', function () {
  if (window.AOS) {
    AOS.init({
      once: true,     // animation happens only once
      duration: 600,  // default duration for all animations
      easing: 'ease', // default easing
    });
  }
});
